import PhotoSizeSelectActualOutlinedIcon from '@mui/icons-material/PhotoSizeSelectActualOutlined';
import { Box, BoxProps, Grid, Paper, Skeleton } from '@mui/material';
import { ReactNode } from 'react';

interface TagContainerProps {
	tagContent: ReactNode;
	after?: ReactNode;
	afterSize?: number;
	img?: string;
	imgSkeleton?: boolean;
	imgPlaceHolder?: boolean;
}

const TagContainer = ({
	tagContent,
	after,
	afterSize,
	img,
	imgSkeleton,
	imgPlaceHolder,
	onClick,
}: TagContainerProps & BoxProps) => {
	const contentSize = 12 - (img || imgPlaceHolder ? 2 : 0) - (afterSize || 0);

	return (
		<>
			<Paper
				sx={{
					width: '100%',
					height: '100%',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					borderRadius: 3,
				}}
				elevation={3}
			>
				<Box
					sx={{
						width: '100%',
						height: '100%',
						textTransform: 'none',
					}}
					onClick={onClick}
					p={0.5}
				>
					<Grid container direction="row" p={1}>
						{img ? (
							<Grid
								container
								item
								xs={2}
								alignItems="center"
								justifyContent="center"
							>
								<Box
									component="img"
									sx={{
										width: '100%',
									}}
									alt="preview"
									src={`${process.env.REACT_APP_DOMAIN_NAME}${process.env.REACT_APP_API_GET_IMAGE}?name=${img}`}
								/>
							</Grid>
						) : imgSkeleton ? (
							<Grid item xs={2}>
								<Skeleton
									variant="rounded"
									animation="wave"
									height="100%"
								/>
							</Grid>
						) : imgPlaceHolder ? (
							<Grid
								container
								item
								xs={2}
								alignItems="center"
								justifyContent="center"
								sx={{
									background: '#E9E9E9',
									borderRadius: '4px',
								}}
							>
								<PhotoSizeSelectActualOutlinedIcon
									sx={{
										width: '80%',
										height: '100%',
										color: '#D2D2D2',
									}}
								/>
							</Grid>
						) : null}
						<Grid
							container
							item
							xs={contentSize}
							alignItems="center"
						>
							{tagContent}
						</Grid>
						{after ? (
							<Grid
								container
								item
								xs={afterSize || 0}
								alignItems="center"
								justifyContent="flex-end"
							>
								{after}
							</Grid>
						) : null}
					</Grid>
				</Box>
			</Paper>
		</>
	);
};

export default TagContainer;
